import React from "react";
import { usePathname } from "next/navigation";

export const useParamUpdater = () => {
  const pathname = usePathname();

  const createParamString = React.useCallback(
    (value: string, index: number) => {
      let segments = pathname.split("/").filter((segment) => segment);
      if (segments.length >= index) {
        segments[index] = value;
        return `/${segments.join("/")}`;
      }
    },
    [pathname]
  );

  return { createParamString };
};
